import React from "react";

import styled from "styled-components";
import Highlight, { defaultProps } from "prism-react-renderer";
import dracula from 'prism-react-renderer/themes/oceanicNext';

export default function OneComponetSC(props) {
    const fileCode = props.fileCode;

    const Pre = styled.pre`
      text-align: left;
      margin: 1em 0;
      padding: 0.5em;
      overflow: scroll;
    
      & .token-line {
        line-height: 1.3em;
        height: 1.3em;
      }
    `;

    const Line = styled.div`
      display: table-row;
    `;

    const LineNo = styled.span`
      display: table-cell;
      text-align: right;
      padding-right: 1em;
      user-select: none;
      opacity: 0.5;
    `;

    const LineContent = styled.span`
      display: table-cell;
    `;
    function CopyToClipboard() {
        navigator.clipboard.writeText(fileCode)

    }
    return (
        <>
            <h5>{props.fileName}:</h5>

            <Highlight {...defaultProps} theme={dracula} code={props.fileCode} language={props.fileType}>
                {({ className, style, tokens, getLineProps, getTokenProps }) => (
                    <Pre className={className} style={style}>
                        <button onClick={() => { CopyToClipboard() }}>Copy</button>

                        {tokens.map((line, i) => (
                            <Line key={i} {...getLineProps({ line, key: i })}>
                                <LineNo>{i + 1}</LineNo>
                                <LineContent>

                                    {line.map((token, key) => (
                                        <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                </LineContent>
                            </Line>
                        ))}
                    </Pre>
                )}
            </Highlight>
        </>

    )
}
